// 刚刚封装的axios
import request from '../index.js';

//首页顶部统计数据
export const totalData = (query) => {
  return request({
      url: '/iotIndex/getTotalData',
      method: 'GET',
      data: query
  })
}
// 线路树形列表
export const lineTree = (query) => {
  return request({
      url: '/iotLine/getIotLineTree',
      method: 'GET',
      params: query
  })
}
// 线路树形列表
export const getAllLine = (query) => {
  return request({
      url: '/iotLine/getAllLine',
      method: 'GET',
      params: query
  })
}
// 桥梁树形列表
export const bridgeTree = (query) => {
  return request({
      url: '/iotBride/getIotBrideTree',
      method: 'GET',
      params: query
  })
}
// 设备树形列表
export const deviceTree = (query) => {
  return request({
      url: '/iotDevice/getIotDeviceTree',
      method: 'GET',
      params: query
  })
}

